import React from 'react';
import { default as MapListGroup } from './MapListGroup';
import { 
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    UncontrolledAccordion,
    UncontrolledTooltip,
} from 'reactstrap';

export default function MapStats({mapData}) {
    return (
        <div>
            {mapData.map((map, index) => (
                <UncontrolledAccordion className='mt-2' key={`accordion-${index.toString()}`} open='false'>
                    <AccordionItem>
                        <AccordionHeader targetId={index.toString()}>
                            <UncontrolledTooltip
                                placement="top"
                                target={'lb' + index}
                                >
                                View Leaderboard
                            </UncontrolledTooltip>
                            <a className="link-no-shadow" id={'lb' + index} href={`/map/${encodeURIComponent(map.map)}`}>{map.map}</a>
                        </AccordionHeader>
                        <AccordionBody accordionId={index.toString()}>
                            {<MapListGroup map={map} />}
                        </AccordionBody>
                    </AccordionItem>
                </UncontrolledAccordion>
            ))}
        </div>
    )
}